import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: resolve => require(['../components/user/Login.vue'], resolve)
    },
    {
      path: '/home',
      meta: {
        title: '工作台',
      },
      component: resolve => require(['../components/Home.vue'], resolve),
      children: [
        {
          path: '/',
          component: resolve => require(['../components/Index.vue'], resolve)
        },
        {
          path: '/package',
          meta: {
            title: '我的套餐',
          },
          component: resolve => require(['../components/package/index.vue'], resolve)
        },
        {
          path: '/project',
          meta: {
            title: '项目管理',
          },
          component: resolve => require(['../components/project/index.vue'], resolve)
        },
        {
          path: '/project/detail',
          meta: {
            title: '项目管理',
            showTitle: false
          },
          component: resolve => require(['../components/project/details.vue'], resolve)
        },
        {
          path: '/template',
          meta: {
            title: '报名模板',
          },
          component: resolve => require(['../components/template/index.vue'], resolve)
        },
        {
          path: '/user',
          meta: {
            title: '用户管理',
          },
          component: resolve => require(['../components/user/Users.vue'], resolve)
        },
        {
          path: '/group',
          meta: {
            title: '用户组',
          },
          component: resolve => require(['../components/user/Roles.vue'], resolve)
        },
        {
          path: '/statistics',
          meta: {
            title: '统计报表',
          },
          component: resolve => require(['../components/statistics/Index.vue'], resolve)
        },
        {
          path: '/password',
          meta: {
            title: '修改密码',
          },
          component: resolve => require(['../components/system/ChangePassword.vue'], resolve)
        },
        {
          path: '/setting',
          meta: {
            title: '基本设置',
          },
          component: resolve => require(['../components/system/BasicSettings.vue'], resolve)
        },
        {
          path: '/pay',
          meta: {
            title: '支付接口',
          },
          component: resolve => require(['../components/system/PaymentConfig.vue'], resolve)
        },
        {
          path: '/logs',
          meta: {
            title: '日志管理',
          },
          component: resolve => require(['../components/system/LogManagement.vue'], resolve)
        },

      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js